import React from 'react';
const Header = () => {
  return <header className="w-full bg-[#804C5C] text-white" data-id="element-238">
      <div className="max-w-6xl mx-auto px-4 py-3" data-id="element-239">
        <div className="flex justify-between items-center" data-id="element-240">
          <div data-id="element-241">
            <img src="https://cdn.shopify.com/s/files/1/0915/4058/6876/files/2_c25fbbee-f30c-45d2-b087-7e1fc46f23d4.png?v=1749850105" alt="Glowly" className="h-7" data-id="element-242" />
          </div>
          <nav className="hidden md:flex space-x-6 text-sm" data-id="element-243">
            <a href="#" className="hover:underline" data-id="element-244">
              FŐOLDAL
            </a>
            <a href="#" className="hover:underline" data-id="element-245">
              HÍREK
            </a>
            <a href="#" className="hover:underline" data-id="element-246">
              EGÉSZSÉG
            </a>
            <a href="#" className="hover:underline" data-id="element-247">
              SZÉPSÉG
            </a>
            <a href="#" className="hover:underline" data-id="element-248">
              KAPCSOLAT
            </a>
          </nav>
        </div>
      </div>
      <div className="w-full bg-black/10 py-1" data-id="element-249">
        <div className="max-w-6xl mx-auto px-4 text-xs" data-id="element-250">
          <span data-id="element-251">FRISS HÍREK | EGÉSZSÉG | HAJÁPOLÁS | 2025.06.15</span>
        </div>
      </div>
    </header>;
};
export default Header;